export default "__VITE_ASSET__d45579ee__"